import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrl: './custom-tooltip.component.scss'
})
export class CustomTooltipComponent {

  @Input() btnCaption?: string;

  @Input() customValue: boolean = false;

  @Input() myTooltip = '';

  @Output() clickMyButton = new EventEmitter();

  onClick() {
    this.clickMyButton.next(true);
  }

}
